export default __webpack_public_path__ + "static/media/home-slider-56.3c8964c9.jpg";